'use client';

import {
  useGetMarketsField,
  useMarketConfig,
  useMarketResolutionThreshold,
} from '@morfi/backend-sdk-v2/client';
import { type Context, createContext, type ReactNode, useContext } from 'react';

const FeedMarketThresholdContext: Context<string | null | undefined> = createContext<
  string | null | undefined
>(undefined);

export function FeedMarketThresholdProvider(props: {
  pubkey: string;
  children: ReactNode;
}): ReactNode {
  const { pubkey, children } = props;
  const config = useMarketConfig(useGetMarketsField(pubkey, 'marketConfig'));
  const status = useGetMarketsField(pubkey, 'status');
  const outcomeCount = useGetMarketsField(pubkey, 'outcomeCount');
  const tradingStartedAt = useGetMarketsField(pubkey, 'tradingStartedAt');
  const resolvedAt = useGetMarketsField(pubkey, 'resolvedAt');
  const threshold = useMarketResolutionThreshold({
    marketPubkey: pubkey,
    config,
    status: status ?? 'created',
    outcomeCount: Number(outcomeCount ?? 0),
    tradingStartedAt: tradingStartedAt ?? null,
    resolvedAt: resolvedAt ?? null,
  });

  return (
    <FeedMarketThresholdContext.Provider
      value={threshold.kind === 'ready' ? threshold.thresholdPpb.toString() : null}
    >
      {children}
    </FeedMarketThresholdContext.Provider>
  );
}

export function useFeedMarketThreshold(): string | null {
  const threshold = useContext(FeedMarketThresholdContext);
  if (threshold === undefined) {
    throw new Error('Feed market threshold requires FeedMarketThresholdProvider');
  }
  return threshold;
}
